import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WebSocketService {
  private socket$!: WebSocketSubject<any>;
  private wsDataSubject = new BehaviorSubject<any>(null);
  connectionCount:number = 0
  // Flag to prevent reconnection after a manual close.
  private manualClose = false;
  
  private baseUrl = 'ws://3.108.203.104:8080';
  private queryParams = new URLSearchParams({
    auth_key: 'RadiusAshu',
    user_id: 'admin123',
    role: 'admin',
    role_id: '1',
  }).toString();

  // Single source of truth for connection status.
  private isConnected = false;

  connect(): void {
    // ✅ CHECK: If socket is already open, don't open it again.
    if (this.isConnected) {
      console.log('WebSocket is already connected. Skipping new connection request.');
      return;
    }

    // Reset the manual close flag on a new connection attempt.
    this.manualClose = false;
    const fullUrl = `${this.baseUrl}?${this.queryParams}`;
    console.log('Connecting to WebSocket:', fullUrl);

    this.socket$ = webSocket({
      url: fullUrl,
      openObserver: {
        next: () => {
          console.log('WebSocket connection established.');
          this.isConnected = true;
        },
      },
      closeObserver: {
        next: (closeEvent) => {
          console.warn('WebSocket connection closed.', closeEvent);
          this.isConnected = false;
          // Only reconnect if it was not a manual close.
          if (!this.manualClose && this.connectionCount<2) {
            this.reconnect();
            
          }
        },
      },
    });

    // Subscribe to incoming messages and forward them to the BehaviorSubject.
    this.socket$.subscribe({
      next: (msg) => this.wsDataSubject.next(msg),
      error: (err) => console.error('WebSocket error:', err), // The closeObserver handles reconnection.
    });
  }

  private reconnect(): void {
    this.connectionCount += 1
    console.log('Attempting to reconnect in 3 seconds...');
    setTimeout(() => {
      this.connect();
    }, 3000);
  }

  sendMessage(msg: any): void {
    if (this.isConnected) {
      this.socket$.next(msg);
    } else {
      console.warn('WebSocket not connected. Message not sent:', msg);
    }
  }

  getMessages(): Observable<any> {
  
    return this.wsDataSubject.asObservable();
  }

  close(): void {
    // ✅ CHECK: If socket is already closed, don't close it again.
    if (!this.isConnected) {
      console.warn('WebSocket is already closed. Skipping close request.');
      return;
    }

    if (this.socket$) {
      console.log('Manually closing WebSocket connection.');
      this.manualClose = true;
      this.socket$.complete(); // This will trigger the closeObserver.
      this.isConnected = false; // Set state immediately for rapid sequential calls.
    }
  }
}